import { ProviderSignature, ProviderSignatureControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */

interface Params {
  providerSignature: ProviderSignature;
  xTENANTID?: string;
}

export const useAddSignature = () =>
  useMutationWithLoading(async (params: Params) =>
    new ProviderSignatureControllerApi(getConfigObject()).createProviderSignature(
      params.providerSignature,
      params.xTENANTID
    ) as Promise<ProviderSignature>
  );
